export default __webpack_public_path__ + "static/icon-18-2-b1426771da72089d3c9257acbea99fe6.png";